import React from "react";
import receivingAppIconImage from "./receivingAppIcon.png";

export default function ReceivingAppIcon() {
	return (
		<div>
			<img src={receivingAppIconImage} alt="Receiving App Icon" />
		</div>
	);
}
